var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkontakte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_91)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_275_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0Z",
    fill: "#2787F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7247 5.11805C13.8081 4.85783 13.7247 4.66663 13.3277 4.66663H12.0149C11.681 4.66663 11.5271 4.8318 11.4437 5.01394C11.4437 5.01394 10.7761 6.53615 9.83023 7.52496C9.52436 7.8112 9.38528 7.90224 9.21841 7.90224C9.13493 7.90224 9.01411 7.8112 9.01411 7.55096V5.11805C9.01411 4.80579 8.91714 4.66663 8.63898 4.66663H6.576C6.36743 4.66663 6.242 4.81155 6.242 4.94891C6.242 5.24492 6.71484 5.31318 6.76353 6.14588V7.95432C6.76353 8.35079 6.68712 8.42272 6.52016 8.42272C6.0751 8.42272 4.99253 6.89367 4.35046 5.14406C4.22463 4.80399 4.09843 4.66663 3.76291 4.66663H2.45011C2.07502 4.66663 2 4.8318 2 5.01394C2 5.33921 2.44507 6.95247 4.07231 9.08625C5.15714 10.5434 6.68556 11.3333 8.07634 11.3333C8.91081 11.3333 9.01411 11.1579 9.01411 10.8557V9.75437C9.01411 9.40349 9.09323 9.33345 9.35748 9.33345C9.55216 9.33345 9.88591 9.42449 10.6648 10.1271C11.5549 10.9598 11.7017 11.3333 12.2023 11.3333H13.5152C13.8903 11.3333 14.0778 11.1579 13.9696 10.8117C13.8512 10.4666 13.4263 9.96597 12.8623 9.37249C12.5564 9.03417 12.0973 8.66993 11.9583 8.48776C11.7636 8.2536 11.8192 8.14944 11.9583 7.94128C11.9583 7.94128 13.5577 5.83362 13.7247 5.11805Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_275_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakte);
export default __webpack_public_path__ + "static/media/vkontakte.db1253cd4b5a84a5e82869cf26e9ada1.svg";
export { ForwardRef as ReactComponent };